import React from "react";

const ToggleSwitch = ({
  checked,
  disabled = false,
  onClick,
  primaryText = "",
  secondaryText = "",
  primaryTextClass = "text-[var(--toggle-switch-text-fg)] text-[length:var(--toggle-switch-text-fs)] font-[var(--toggle-switch-text-fw)]",
  secondaryTextClass = "text-[var(--toggle-switch-text-fg)] text-[length:var(--toggle-switch-text-fs)] font-[var(--toggle-switch-text-fw)]",
}) => {
  return (
    <div className="flex items-center gap-2">
      <span className={primaryTextClass}>{primaryText}</span>
      <button
        disabled={disabled}
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={onClick}
        className={`relative inline-flex h-[16px] w-[32px] items-center rounded-full transition-colors duration-200 ease-in-out ${
          checked
            ? "bg-[var(--toggle-switch-bg)]"
            : "bg-[var(--toggle-switch-off-bg)]"
        }`}
        aria-label="Toggle Switch"
      >
        <span
          className={`inline-block h-[12px] w-[12px] transform rounded-full bg-[var(--toggle-switch-fg)] transition-transform duration-200 ease-in-out ${
            checked ? "translate-x-[16px]" : "translate-x-[2px]"
          }`}
        />
      </button>
      <span className={secondaryTextClass}>{secondaryText}</span>
    </div>
  );
};

export default ToggleSwitch;
